import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.styl';

function ProgressBar({ progress, height, withTransition, transitionDuration }) {
  const style = {
    width: `${progress}%`,
    ...(transitionDuration && { transitionDuration }),
  };

  return (
    <div className={styles.bar} style={{ height }}>
      <div
        className={cn(styles.line, {
          [styles.lineWithTransition]: withTransition,
        })}
        style={style}
      />
    </div>
  );
}

ProgressBar.propTypes = {
  height: PropTypes.number,
  progress: PropTypes.number,
  withTransition: PropTypes.bool,
  transitionDuration: PropTypes.string,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/Components/Progress/ProgressBar.jsx